import React from "react";
import FeedbackLink from "../../../components/FeedbackLink";
import { ItemText2 } from "../../../styles";
import { Colors } from "../../../styles/theme";
import { Button } from "@mui/material";

function NavLinks({ links, pathname, onClick, isRtl = true }) {
  return links.map(({ label, to, icon: Icon }) => {
    const isActive = pathname === to;

    // Dynamically pick icon slot based on RTL configuration
    const iconProps = Icon
      ? {
          [isRtl ? "endIcon" : "startIcon"]: (
            <Icon
              sx={{
                fontSize: "1.25rem !important",
                color: isActive ? Colors.color1 : "#757575",
                // Mirror the transition effect of the text wrapper
                transition: "color 0.2s ease",
              }}
            />
          ),
        }
      : {};

    return (
      <FeedbackLink
        key={to}
        to={to}
        onClick={onClick}
        style={{ textDecoration: "none", width: "100%" }}
      >
        <Button
          fullWidth
          {...iconProps} // Spreads startIcon or endIcon dynamically
          sx={{
            // Keeps layout uniform and respects textual gravity
            justifyContent: "space-between",
            flexDirection: isRtl ? "row-reverse" : "row",
            textAlign: isRtl ? "right" : "left",
            padding: "12px 0px",
            borderRadius: "8px",
            color: isActive ? Colors.color1 : "#4a4a4a",
            backgroundColor: isActive ? "#f5fdf9" : "transparent",
            borderLeft:
              !isRtl && isActive ? `4px solid ${Colors.color1}` : "none",
            borderRight:
              isRtl && isActive ? `4px solid ${Colors.color1}` : "none",
            textTransform: "none",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "#fafafa",
              color: Colors.color1,
              "& .MuiButton-startIcon, & .MuiButton-endIcon": {
                color: Colors.color1, // Hover sync for the icon
              },
            },
          }}
        >
          <ItemText2
            sx={{
              fontSize: "0.95rem",
              fontWeight: isActive ? 600 : 500,
              flexGrow: 1, // Ensures label pushes icon to correct edges
            }}
          >
            {label}
          </ItemText2>
        </Button>
      </FeedbackLink>
    );
  });
}
export default React.memo(NavLinks);
